import { render } from "./ProductsProductLimit.vue?vue&type=template&id=33779a78"
import script from "./ProductsProductLimit.vue?vue&type=script&lang=js"
export * from "./ProductsProductLimit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__